// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KgITqZ {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-1);
}

.xSK_FH {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  height: 28px;
}

.ym6tYw {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: var(--spacing-3);
}

.Ryrjlg {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  background: var(--product-card-background);
  border-radius: var(--radius-s);
  box-shadow: var(--card-box-shadow);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  flex: 1;
  height: 120px;
  text-decoration: none;
  color: inherit;
}

.MNueUC {
  border: none;
  text-align: left;
  font-family: inherit;
  font-size: inherit;
}

.ym6tYw .Ryrjlg:hover {
  transform: translateY(-2px);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
}

.ym6tYw .Ryrjlg:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
}

.VLH2u6 {
  display: flex;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.VLH2u6 svg,
.VLH2u6 img {
  width: 16px;
  height: 16px;
  filter: var(--product-card-icon-filter);
}

.n1EyVY {
  font-family: var(--font-family-base);
  font-weight: var(--type-label-sm-regular-font-weight);
  font-size: var(--type-label-sm-font-size);
  line-height: var(--type-label-sm-regular-line-height);
  color: var(--product-card-title-color);
  margin: 0;
  text-align: left;
  align-self: stretch;
}

@media (max-width: 768px) {
  .ym6tYw {
    gap: var(--spacing-1);
  }

  .Ryrjlg {
    height: 100px;
  }

  .n1EyVY {
    font-size: var(--type-label-xs-font-size);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/LinksList/LinksList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,0CAA0C;EAC1C,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf;;wBAEsB;EACtB,OAAO;EACP,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,yCAAyC;EACzC,qDAAqD;EACrD,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-1);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  height: 28px;\n}\n\n.linksGrid {\n  display: flex;\n  flex-direction: row;\n  align-self: stretch;\n  gap: var(--spacing-3);\n}\n\n.linkItem {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px;\n  background: var(--product-card-background);\n  border-radius: var(--radius-s);\n  box-shadow: var(--card-box-shadow);\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n  flex: 1;\n  height: 120px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.linkItemButton {\n  border: none;\n  text-align: left;\n  font-family: inherit;\n  font-size: inherit;\n}\n\n.linksGrid .linkItem:hover {\n  transform: translateY(-2px);\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);\n}\n\n.linksGrid .linkItem:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n}\n\n.linkIcon {\n  display: flex;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.linkIcon svg,\n.linkIcon img {\n  width: 16px;\n  height: 16px;\n  filter: var(--product-card-icon-filter);\n}\n\n.linkLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-label-sm-regular-font-weight);\n  font-size: var(--type-label-sm-font-size);\n  line-height: var(--type-label-sm-regular-line-height);\n  color: var(--product-card-title-color);\n  margin: 0;\n  text-align: left;\n  align-self: stretch;\n}\n\n@media (max-width: 768px) {\n  .linksGrid {\n    gap: var(--spacing-1);\n  }\n\n  .linkItem {\n    height: 100px;\n  }\n\n  .linkLabel {\n    font-size: var(--type-label-xs-font-size);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KgITqZ`,
	"title": `xSK_FH`,
	"linksGrid": `ym6tYw`,
	"linkItem": `Ryrjlg`,
	"linkItemButton": `MNueUC`,
	"linkIcon": `VLH2u6`,
	"linkLabel": `n1EyVY`
};
module.exports = ___CSS_LOADER_EXPORT___;
